import { Reducer, AnyAction, Action } from 'redux';
import { OperationsListState } from './types-store';
import {
  ACTION, ClearList,
  RequestOperationsList, ReceiveOperationsList, FailOperationsList,
  RequestUpdateOperations, ReceiveUpdateOperations, FailUpdateOperations
} from './action-types';
import { createOperationsList } from 'app/area/experience-transfer/operations/create-operations-list';

export const INITIAL_STATE: OperationsListState = {
  requestId: 0,
  fetching: false,
  updating: false,
  requestedSearchModel: undefined,
  numberOfResults: undefined,
  listItems: undefined
};

const reducers: { [indexer: string]: Reducer<OperationsListState, Action> } = {

  [ACTION.CLEAR_LIST]: (state: OperationsListState, action: ClearList): OperationsListState => {
    return {
      ...state,
      requestId: action.requestId,
      fetching: false,
      requestedSearchModel: undefined,
      numberOfResults: undefined,
      listItems: undefined
    };
  },

  [ACTION.REQUEST_OPERATIONS_LIST]: (state: OperationsListState, action: RequestOperationsList): OperationsListState => {

    return {
      ...state,
      requestId: action.requestId,
      fetching: true,
      requestedSearchModel: action.model,
      numberOfResults: undefined,
      listItems: undefined

    };
  },

  [ACTION.RECEIVE_OPERATIONS_LIST]: (state: OperationsListState, action: ReceiveOperationsList): OperationsListState => {

    if (action.requestId !== state.requestId) {
      return state;
    }

    return {
      ...state,
      fetching: false,
      numberOfResults: action.numberOfResults,
      listItems: [
        ...(state.listItems || []),
        ...action.list
      ]
    };
  },

  [ACTION.FAIL_OPERATIONS_LIST]: (state: OperationsListState, action: FailOperationsList): OperationsListState => {

    if (action.requestId !== state.requestId) {
      return state;
    }

    return {
      ...state,
      fetching: false
    };
  },

  [ACTION.REQUEST_UPDATE_OPERATIONS]: (state: OperationsListState, action: RequestUpdateOperations): OperationsListState => {
    return {
      ...state,
      updating: true,
      listItems: action.listItems
    };
  },

  [ACTION.RECEIVE_UPDATE_OPERATIONS]: (state: OperationsListState, action: ReceiveUpdateOperations): OperationsListState => {
    return {
      ...state,
      updating: false
    };
  },

  [ACTION.FAIL_UPDATE_OPERATIONS]: (state: OperationsListState, action: FailUpdateOperations): OperationsListState => {
    return {
      ...state,
      updating: false,
      listItems: createOperationsList(action.id, state.listItems)
    };
  }
};

export const reducer: Reducer<OperationsListState> = (
  state: OperationsListState = INITIAL_STATE, action: AnyAction) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
